// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalThreeRules_modal__1oYD2"};